import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

import {
  setUserPermission,
  hideEditUser,
  updateSetUserPermissionField,
} from '@actions/admin';
import {
  isSavingUserPermission,
  selectPermissionsFormUserId,
  selectPermissionsFormSelectedPermission,
} from '@selectors/admin';

import EditUser from './EditUser.component';

const mapStateToProps = (state, props) => ({
  userId: selectPermissionsFormUserId(state),
  isSaving: isSavingUserPermission(state),
  selectedPermission: selectPermissionsFormSelectedPermission(state),
});

const mapDispatchToProps = {
  save: setUserPermission,
  cancel: hideEditUser,
  onChange: updateSetUserPermissionField,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
)(EditUser);



// WEBPACK FOOTER //
// ./components/organisms/EditUser/EditUser.container.js